import { ErrorHandler } from '@angular/core';

// Create a new ErrorHandler and report an issue straight to Raygun
export class RaygunErrorHandler implements ErrorHandler {
  handleError(e: any): void {
    if (window.location.hostname === 'app.nuagedx.com') {
      try {
        // Use window.rg4js instead of require() to avoid bundling issues
        if (typeof window !== 'undefined' && (window as any).rg4js) {
          (window as any).rg4js('send', { error: e });
        } else {
          console.warn('Raygun not available, falling back to console error');
        }
      } catch (raygunError) {
        console.error('Raygun error reporting failed:', raygunError);
      }
    }
    console.error(e);
  }
}
